export default __webpack_public_path__ + "static/media/building.b116d85d.jpg";